import React, {useState} from "react"
import {Box} from "@mui/material"
import {useTranslation} from "react-i18next"
import PhoneInput, {type Country} from "react-phone-number-input"
import "react-phone-number-input/style.css"
import {detectDefaultCountry} from "../../library/detectCountry"
import FieldLabel from "./FieldLabel"

const phoneInputContainerSx = {
  "& .PhoneInputInput": {
    border: "none",
    backgroundColor: "#ffffff",
    borderRadius: "4px",
    boxShadow: "0 3px 10px rgb(0 0 0 / 15%)",
    marginLeft: "5px",
    color: "#495057",
    height: "50px",
    paddingLeft: "20px",
    fontSize: "1rem",
    "&:focus": {
      outline: "none",
    },
    "&::placeholder": {
      color: "#999",
    },
  },
  "& .PhoneInputCountry": {
    border: "none",
    backgroundColor: "#ffffff",
    borderRadius: "4px",
    boxShadow: "0 3px 10px rgb(0 0 0 / 15%)",
    padding: "0 12px",
  },
}

interface PhoneNumberFieldProps {
  label: string
  textColor: string
  value: string | null
  onChange: (value?: string) => void
}

export default function PhoneNumberField({label, textColor, value, onChange}: PhoneNumberFieldProps) {
  const {t} = useTranslation()
  const [country, setCountry] = useState<Country>(detectDefaultCountry)

  return (
    <Box sx={{width: "100%"}}>
      <FieldLabel textColor={textColor}>{label}</FieldLabel>
      <Box sx={phoneInputContainerSx}>
        <PhoneInput
          defaultCountry={country}
          placeholder={country === "US" ? t("splash.phoneNumberPlaceholder.US") : ""}
          value={value ?? ""}
          onChange={onChange}
          onCountryChange={(c) => setCountry(c ?? "US")}
        />
      </Box>
    </Box>
  )
}
